import React from "react";

const Notfound = () => {
  return <div>Notfound Page</div>;
};

export default Notfound;
